export default __webpack_public_path__ + "static/media/news072605.ec7e1ec5.jpg";